import type { PixelModule } from '@/runtime/types';
import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import type { DebugSnapshotService } from './DebugSnapshotService';

/**
 * Módulo read-only de diagnóstico (Etapa 16).
 * Sem eventos, timers, listeners ou mutação de estado.
 * Sempre habilitado no Runtime (não depende de ModulesConfig).
 * init/destroy são idempotentes.
 */
export class RuntimeDiagnosticsModule implements PixelModule {
  readonly name = 'diagnostics' as const;

  private readonly snapshotService: DebugSnapshotService;

  private active = false;

  constructor(snapshotService: DebugSnapshotService) {
    this.snapshotService = snapshotService;
  }

  init(_context: PixelRuntimeContext): void {
    if (this.active) return;
    this.snapshotService.markAlive();
    this.active = true;
  }

  destroy(): void {
    if (!this.active) return;
    this.snapshotService.markDestroyed();
    this.active = false;
  }

  getSnapshotService(): DebugSnapshotService {
    return this.snapshotService;
  }
}
